import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import get from 'lodash/get';

import Carousel from 'components/Carousel';
import Header from 'components/Header';
import Kpi from 'components/Kpi';
import TabNavigation from 'components/TabNavigation';
import Survey from 'modules/Notes/components/Survey';
import NotesContainer from 'modules/Notes/components/PageContainer';

import { getNotationHeader } from 'actions/notes';
import { useUserMe } from '../../apiTyped/hooks/users.query';
const isMobile = window.innerWidth <= 1200;

const Notes = ({
  data,
  getNotationHeader,
  children
}: {
  data: any;
  getNotationHeader: () => void;
  children: any;
}) => {
  const { user } = useUserMe();

  useEffect(() => {
    getNotationHeader();
  }, []);

  const getRandomKpi = () => {
    const kpis = get(data, 'ratings', []);
    let randomKpi = kpis[Math.floor(Math.random() * kpis.length)];
    if (!randomKpi) {
      randomKpi = {
        wine_name: '',
        vintage: '',
        wxr: 0,
        date: new Date()
      };
    }
    return randomKpi;
  };

  const getOptionsNavigation = () => {
    const clientTags = user.client.tags;

    let options = [
      {
        label: I18n.t('notes.navigationOptions.notes'),
        active: true,
        route: '/communication/notes'
      },
      {
        label: I18n.t('notes.navigationOptions.compare'),
        active: false,
        route: '/communication/compare'
      }
    ];

    if (!isMobile) {
      options = [
        ...options,
        // @ts-expect-error tags
        ...(clientTags.includes('Bordeaux')
          ? [
              {
                label: I18n.t('notes.navigationOptions.wxr'),
                active: false,
                route: '/communication/wine-expert-rating'
              }
            ]
          : [])
      ];
    }

    return options;
  };

  const randomKpi = getRandomKpi();
  const feed = get(data, 'feed', []);
  const wxrPanels = user.client.wxrPanels;

  return (
    <NotesContainer>
      <Header
        title={I18n.t('notes.title')}
        subTitle={I18n.t('notes.subTitle')}
      />
      <div className="headerContainer">
        <Kpi
          title={`${randomKpi.wine_name} ${randomKpi.vintage}`}
          date={randomKpi.date}
          value={randomKpi.wxr.toFixed(1)}
          dateText={I18n.t('notes.kpi.dateText')}
          valueText="WxR"
          tooltip={I18n.t('notes.kpi.tooltip')}
        />
        {(!isMobile || feed.length > 0) && (
          <Carousel ItemComponent={Survey} data={feed} />
        )}
      </div>
      {wxrPanels.length > 0 && (
        <div className="navigation">
          <TabNavigation buttons={getOptionsNavigation()} />
        </div>
      )}
      {children}
    </NotesContainer>
  );
};

const mapStateToProps = (state: any) => ({
  data: state.notes.header
});

const mapDispatchToProps = (dispatch: any) => ({
  getNotationHeader: () => {
    dispatch(getNotationHeader());
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(Notes);
